<template>
  <base-button v-if="insideDialog" :class="backButton" @click="signIn">
    <vf-icon dir="left" name="chevron" size="md" />
    <span class="text-sm">{{ $t.backToSignIn }}</span>
  </base-button>
  <div data-test-id="form-reset-password-request">
    <h2 :class="[brandClasses.heading, variant && brandClasses.variant?.[variant]?.heading]">
      {{ $t.forgotPasswordTitle }}
    </h2>
    <base-form :class="brandClasses.form" :form validate-on="submit" @submit="submit">
      <vf-form-field
        :hint="$t.emailFormatHint"
        name="username"
        :rule="[validateRequired($t.email), validateEmail()]"
        :variant
        v-slot="{ invalid }"
      >
        <input-email v-model="form.username" :invalid :variant />
      </vf-form-field>
      <slot name="submit-button">
        <vf-button :class="brandClasses.submitButton" :loading :size="buttonSize" type="submit">
          {{ $t.resetPassword }}
        </vf-button>
      </slot>
    </base-form>
  </div>
</template>

<script lang="ts" setup>
const {
  email = '',
  insideDialog,
  preventDialog,
  variant
} = defineProps<{
  email?: string
  insideDialog?: boolean
  preventDialog?: boolean
  variant?: 'inverse'
}>()

const emit = defineEmits<Emits>()
export type Emits = { signIn: [], submit: [] }

const { $t } = useNuxtApp()
const { brandClasses, buttonSize } = useAppConfig().components.form.forgotPassword
const { backButton } = useAppConfig().components.dialog.forgotPassword.brandClasses
const { validateEmail, validateRequired } = useLocalizedValidators()
const recaptcha = useRecaptcha()
const toast = useToaster()
const { DialogSignIn } = useDialogsStore()

const form = reactive({
  username: email
})
const loading = ref(false)

async function submit() {
  loading.value = true
  const captchaResponse = await recaptcha.execute('resetPassword')
  const { username } = form

  await useApi().authentication.$resetPassword({
    username,
    recaptcha_response: captchaResponse
  })

  loading.value = false

  toast.add({
    props: {
      message: $t.forgotPasswordSuccessMessage,
      type: 'success'
    }
  })

  emit('submit')
}

const signIn = () => {
  emit('signIn')
  if (!preventDialog) DialogSignIn.open()
}
</script>
